import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

export const PageLayout = () => {
    return (
        <Suspense
            fallback={
                <div className="grid min-h-screen place-items-center text-xl font-bold">
                    Loading...
                </div>
            }
        >
            <div className="mx-auto max-w-4xl px-4 py-8">
                <Outlet />
            </div>
        </Suspense>
    )
}
